import 'jquery-ui-bundle';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import './index.css';
import 'react-app-polyfill/ie9';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

import { runWithAdal } from 'react-adal';
import { initAuthContext } from './adalConfig';

import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from './TelemetryService';



import $ from 'jquery';

//bootstrap 4.3.1 - Tooltips and Popovers use built-in sanitizer to sanitize options which accept HTML.
//https://getbootstrap.com/docs/4.3/getting-started/javascript/#sanitizer
//extend default witeList to accept specified element types
var defaultWhiteList = $.fn.tooltip.Constructor.Default.whiteList;
defaultWhiteList.form = [];
defaultWhiteList.input = [];
defaultWhiteList.button = [];


// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');

const DO_NOT_LOGIN = false;

ai.initialize({ history: history });

initAuthContext()
    .then(authContext => {
        if (window.location.pathname && window.location.pathname.replace(/\//g, '').toLowerCase() === 'signout') {
            authContext.logOut();
        } else {
            runWithAdal(authContext, () => {
                ReactDOM.render(
                    <Provider store={store}>
                        <ConnectedRouter history={history}>
                            <App />
                        </ConnectedRouter>
                    </Provider>,
                    rootElement);
                registerServiceWorker();
            }, DO_NOT_LOGIN);
        }
    }
    ).catch(error => ReactDOM.render(<div>Initialization error!</div>, rootElement));